module.exports = __webpack_public_path__ + "static/media/login_background_left.916fc903.png";